import { ApiError } from '@modules/checkout-store';

export const readableErrors = (
  err: (string | ApiError | undefined)[]
): string => {
  let msg = 'No message found.';
  const actualValues = err
    .map((error) => extract(error))
    .filter((element): element is string => {
      return !!element && element !== null;
    });
  if (actualValues.length > 0) {
    return actualValues.join(', ');
  }
  return msg;
};

/**
 * Extract a useful error message or 'No message found.'
 * @param err
 * @returns
 */
export const readableError = (err: string | ApiError | undefined): string => {
  let msg = 'No message found.';
  const extracted = extract(err);
  return extracted ?? msg;
};

export const extract = (
  err: string | ApiError | undefined
): string | undefined => {
  if (err) {
    if (typeof err === 'string') {
      if (err.trim().length === 0) {
        return undefined;
      }
      return err as string;
    } else {
      const description = (err as ApiError).shortDescription;
      if (description?.trim().length === 0) {
        return undefined;
      }
      return (err as ApiError).shortDescription;
    }
  }
  return undefined;
};
